import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';
 
export const Banner = () => {

  // const resumeURL = "https://drive.google.com/file/d/1VQqrgGtKS1yZnVPjCE87SOSzNHJKumib/view?usp=sharing";
  const resumeURL = "https://drive.google.com/file/d/1Wp_ImQhcwaTnRizWR7WdcCmpNep3JODw/view?usp=sharing";

  const downloadFileAtURL = (url) =>{
    const aTag = document.createElement("a");
    const fileName = "Piyush_Ninawe_Resume.pdf"
    aTag.href = url;
    aTag.setAttribute("download", fileName);
    document.body.appendChild(aTag);
    aTag.click();
    aTag.remove();
  };

  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = ["A Data Scientist", "A AI-ML Engineer", "A Web Developer"];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text])

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <span className="tagline">Welcome to my Portfolio</span>
                <h1>{`Hi! I'm Piyush, `} <br/><span className="txt-rotate" dataPeriod="1000" data-rotate='["A Data Scientist", "A AI-ML Engineer", "A Web Developer" ]'><span className="wrap">{text}</span></span></h1>
                  <p> An aspiring Computer Science Engineer passionate about AI-driven solutions and advanced analytics.<br/> I have woned my skills through various internships and projects. With a strong foundation in Python, Java, Data Science & Web Development. Explore my projects, certifications, and experiences to learn more about my journey and aspirations in the field of technology.</p>
                  <button onClick={() => {downloadFileAtURL(resumeURL)}}>Download Resume <ArrowRightCircle size={25} /></button>
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
